import React from 'react';
import ClientsPage from '../../clients/pages/ClientsPage';

export default function AdminCustomersPage() {
  return <ClientsPage />;
}
